import { GraficoMonitoramentoEnum } from '../../service-proxies/service-proxies';

export class ChartItem {
  constructor(public name: string, public type: GraficoMonitoramentoEnum) { }
}

export class ChartList {
  charts: ChartItem[] = [
    new ChartItem('Altura', GraficoMonitoramentoEnum._0),
    new ChartItem('Frequência Cardíaca', GraficoMonitoramentoEnum._1),
    new ChartItem('Dor Articular', GraficoMonitoramentoEnum._2),
    new ChartItem('Frequência Respiratória', GraficoMonitoramentoEnum._3),
    new ChartItem('Glicemia', GraficoMonitoramentoEnum._4),
    new ChartItem('Humor', GraficoMonitoramentoEnum._5),
    new ChartItem('Índice de Massa Corporal', GraficoMonitoramentoEnum._6),
    new ChartItem('Oximetria', GraficoMonitoramentoEnum._7),
    new ChartItem('Peso', GraficoMonitoramentoEnum._8),
    new ChartItem('Pressão Arterial', GraficoMonitoramentoEnum._9),
    new ChartItem('Qualidade do Sono', GraficoMonitoramentoEnum._10),
    new ChartItem('Temperatura', GraficoMonitoramentoEnum._11),
  ];

  getNomeGrafico(grafico: GraficoMonitoramentoEnum): string {
    const item = this.charts.find(x => x.type === grafico);
    return item ? item.name : 'Nome não encontrado';
  }
}

